import Color from "color";

const Primary = Color("#0a4da2");
const PrimaryDark = Color("#022d65");
const PrimaryLight = Primary.lighten(0.1);
const Secondary = Color("#03afef");
const SecondaryDark = Secondary.darken(0.1);
const SecondaryLight = Secondary.lighten(0.1);
const Muted = Color("#898989");
const Gray = Color("#e5e5e5");
const GrayLight = Color("#f2f2f2");
const GrayDark = Muted;
const Success = Color("#39d300");
const Default = Gray;
const Info = Color("#31b0d5");
const Danger = Color("#e90025");
const Warning = Color("#f79900");
const Bg = Color("#fff");
const Text = Color("#464646");
const Link = Secondary;
const LinkActive = SecondaryLight;
const Footer = Color("#077ec9");

export default {
  Primary,
  PrimaryDark,
  PrimaryLight,
  Secondary,
  SecondaryDark,
  SecondaryLight,
  Muted,
  Gray,
  GrayLight,
  GrayDark,
  Success,
  Default,
  Info,
  Danger,
  Warning,
  Bg,
  Text,
  Link,
  LinkActive,
  Footer
};
